module.exports = __webpack_public_path__ + "static/media/arrow-up.819c4b2d.svg";